import { z } from 'zod'

export const FormSchema = z.object({
  first_name: z.string().min(1, 'First name is required'),
  last_name: z.string().min(1, 'Last name is required'),
  email: z.string().pipe(z.email('A valid email is required')),
  country_id: z.number().int().positive('Country is required'),
  company_name: z.string().optional(),
  message: z.string().min(1, 'Message is required'),
})

export type FormSchemaType = z.infer<typeof FormSchema>
